/**
 * Role gates for web-billing controls. UX only: the API enforces every permission
 * (three-layer security). Each set mirrors ROLE_PERMISSIONS in shared permissions.ts,
 * whose holder lists are pinned in permissions.test.ts.
 */

/**
 * EDIT_BILLING_TICKET holders (DEC-356, #50 choice 7): both admins, both billing roles and
 * all four combined office roles. NOT Truck Pusher or Dispatch Manager.
 */
export const EDIT_BILLING_TICKET_ROLES: ReadonlySet<string> = new Set([
  'PLATFORM_ADMIN',
  'TENANT_ADMIN',
  'BILLING_MANAGER',
  'BILLING_STAFF',
  'DISPATCHER_BILLING_STAFF',
  'DISPATCHER_BILLING_MANAGER',
  'DISPATCH_MANAGER_BILLING_STAFF',
  'DISPATCH_MANAGER_BILLING_MANAGER',
]);

/**
 * OPEN-156 — who may void an approved ticket: VOID_BILLING_TICKET in shared/auth/permissions.ts
 * (TenAdmin, BillMgr and the combined billing-manager roles; not PlatAdmin or BillStaff). A UX
 * gate only; the API enforces it.
 */
export const VOID_BILLING_TICKET_ROLES: ReadonlySet<string> = new Set([
  'TENANT_ADMIN',
  'BILLING_MANAGER',
  'DISPATCHER_BILLING_MANAGER',
  'DISPATCH_MANAGER_BILLING_MANAGER',
]);
